export const guestComps = {
  detail: {
    nav: {
      overview: "Informationen",
      bookings: "Buchungen",
      checkins: "Check-ins",
      invoicing: "Rechnungsstellung",
    },
    personalInfo: "Persönliche Daten",
    contactInfo: "Kontaktdaten",
    residenceInfo: "Angaben zum Wohnsitz",
    fields: {
      firstName: "Vorname",
      lastName: "Nachname",
      document: "Dokument",
      nationality: "Staatsangehörigkeit",
      country: "Land",
      birthDate: "Geburtsdatum",
      email: "E-Mail",
      whatsapp: "WhatsApp",
      countryResidence: "Wohnsitzland",
      cityResidence: "Wohnort",
      relationship: "Verwandtschaftsverhältnis",
    },
    cols: {
      code: "Code",
      accommodation: "Unterkunft",
      checkIn: "Check-in",
      checkOut: "Check-out",
      status: "Status",
      total: "Summe",
      guest: "Gast",
      booking: "Buchung",
      entryDate: "Anreisedatum",
      date: "Datum",
    },
    confirmed: "Bestätigt",
    fiscalProfile: "Hinterlegtes Steuerprofil",
    legalName: "Firmenname",
    taxId: "Steuernummer",
    type: "Typ",
    company: "Unternehmen",
    individual: "Privatperson",
    invoicesIssued: "Ausgestellte Rechnungen",
    empty: {
      bookings: "Für diesen Gast sind keine Buchungen erfasst.",
      checkins: "Für diesen Gast sind keine Check-ins erfasst.",
      invoices: "Für diesen Gast wurden keine Rechnungen ausgestellt.",
    },
    noPdf: "Kein PDF",
    status: {
      sent: "Ausgestellt",
      processing: "In Bearbeitung",
      error: "Fehler",
      pending: "Ausstehend",
    },
    close: "Schließen",
  },
  form: {
    editTitle: "Kunde bearbeiten",
    newTitle: "Neuer Kunde",
    subtitle: "Kontakt- und Rechnungsdaten für kommende Buchungen und Rechnungen.",
    subtitleEmbedded: "Vervollständigen Sie das Profil und Sie kehren zur Rechnung zurück, ohne die Positionen zu verlieren.",
    backToInvoice: "Zurück zur Rechnung",
    close: "Schließen",
    customerTypeAria: "Kundentyp",
    typeIndividual: "Privatperson",
    typeIndividualHelp: "Natürliche Person",
    typeCompany: "Unternehmen",
    typeCompanyHelp: "Juristische Person",
    identity: "Identität",
    identityDesc: "Angaben, die den Rechnungsempfänger identifizieren.",
    name: "Vorname",
    namePlaceholder: "Max",
    lastName: "Nachname",
    lastNamePlaceholder: "Mustermann",
    legalName: "Firmenname",
    legalNamePlaceholder: "Beispiel GmbH",
    docTaxId: "NIF / CIF / USt-IdNr.",
    docFiscal: "Steuerdokument",
    docPlaceholderIndividual: "DNI, NIE oder Reisepass",
    docType: "Dokumentart",
    select: "Auswählen",
    docDni: "DNI",
    docNie: "NIE",
    docPassport: "Reisepass",
    docOther: "Anderes Dokument",
    contact: "Kontakt",
    contactDesc: "Kanäle, um die Rechnung zu senden oder den Kunden zu erreichen.",
    email: "E-Mail",
    emailPlaceholder: "kunde@email.com",
    phone: "Telefon",
    fiscalAddress: "Steueranschrift",
    fiscalAddressDesc: "Wird auf einer vollständigen Rechnung als Anschrift des Empfängers verwendet.",
    country: "Land",
    address: "Adresse",
    addressPlaceholder: "Straße, Hausnummer und Stockwerk",
    city: "Stadt",
    cityPlaceholder: "Madrid",
    state: "Provinz / Bundesland",
    postalCode: "Postleitzahl",
    postalPlaceholder: "28001",
    requiredNote: "* Pflichtfelder für das Steuerprofil",
    backToInvoiceShort: "Zurück zur Rechnung",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    saveChanges: "Änderungen speichern",
    createClient: "Kunde anlegen",
    err: {
      name: "Geben Sie den Vornamen ein.",
      lastName: "Geben Sie den Nachnamen ein.",
      legalName: "Geben Sie den Firmennamen ein.",
      taxId: "Für Unternehmen ist die Steuernummer erforderlich.",
      country: "Wählen Sie das Land aus.",
      address: "Geben Sie die Steueranschrift ein.",
      city: "Geben Sie die Stadt ein.",
      postalCode: "Geben Sie die Postleitzahl ein.",
      email: "Geben Sie eine gültige E-Mail-Adresse ein.",
      saveFailed: "Der Kunde konnte nicht gespeichert werden.",
    },
  },
  list: {
    title: "Rechnungskunden",
    subtitle: "Wiederverwendbare Steuerprofile zum Ausstellen und Prüfen von Rechnungen",
    searchLabel: "Kunden suchen",
    searchPlaceholder: "Name, E-Mail, Telefon oder Dokument…",
    clearSearch: "Suche zurücksetzen",
    exporting: "Wird exportiert...",
    exportClients: "Kunden exportieren",
    newClient: "Neuer Kunde",
    cols: {
      fiscalClient: "Steuerlicher Kunde",
      contact: "Kontakt",
      fiscalDocument: "Steuerdokument",
      country: "Land",
      linkedBookings: "Verknüpfte Buchungen",
      invoices: "Rechnungen",
      actions: "Aktionen",
    },
    company: "Unternehmen",
    individual: "Privatperson",
    noEmail: "Keine E-Mail hinterlegt",
    noPhone: "Keine Telefonnummer hinterlegt",
    viewInvoicesTitle: "{count} Rechnung dieses Gastes ansehen | {count} Rechnungen dieses Gastes ansehen",
    invoicesCount: "{count} Rechnung | {count} Rechnungen",
    noInvoices: "Keine Rechnungen",
    editClient: "Kunde bearbeiten",
    edit: "Bearbeiten",
    viewDetail: "Details ansehen",
    view: "Ansehen",
    emptySearchTitle: "Keine Steuerprofile gefunden",
    emptySearchSub: "Keine Rechnungskunden passen zu „{term}“.",
    emptyTitle: "Noch keine Rechnungskunden",
    emptySub: "Legen Sie beim Ausstellen einer Rechnung ein Steuerprofil an oder speichern Sie jetzt eines, um es später wiederzuverwenden.",
    createFirst: "Ersten Kunden anlegen",
    selectedClient: "Ausgewählter Kunde",
  },
  internalName: {
    addBtn: "interner Name",
    title: "Interner Name",
    hint: "Nur Sie sehen ihn. Er steht in Ihren Listen und Kalendern vor dem öffentlichen Namen.",
    removeWarn: "Er verschwindet aus Ihren Listen. Nachrichten mit Zugangscodes und der KI-Agent geben dann nicht mehr an, um welche Unterkunft es geht.",
    edit: "Bearbeiten",
    cancel: "Abbrechen",
    removing: "Wird entfernt…",
    confirmRemove: "Ja, entfernen",
    remove: "Entfernen",
    editTitle: "Internen Namen bearbeiten",
    addTitle: "Internen Namen hinzufügen",
    eyebrow: "Interner Name der Unterkunft",
    modalHint: "Ein privater Name, damit Sie die Unterkunft auf einen Blick erkennen (zum Beispiel «Dachgeschoss Roser» oder «Zweiter Stock»). Ihre Gäste sehen ihn nie.",
    placeholder: "Dachgeschoss Roser",
    previewLabel: "So sehen Sie es",
    saving: "Wird gespeichert…",
    save: "Speichern",
    saveFailed: "Der interne Name konnte nicht gespeichert werden.",
  },
};
